module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Favorites.84f98fb4.svg";